<template>
  <div>
    <a href="javascript:void(0);" @click="$emit('ck')">
      <li>
        <slot name="icon"> </slot>
        <slot name="txt"></slot>
      </li>
      <!-- <li class="copy-link"><i class="fa fa-clone mr-1"></i> 複製連結</li> -->
    </a>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Social/moreMenu.vue